import React from "react";
import withProviders from "../../hooks/withProviders";
import ApplicationDocuments from "../../features/applicationdocuments";
import { FilterProvider, ApplicationDocumentsDefaultFilters } from "../../hooks/FilterContext";

const ApplicationsDocumentsPage = () => <ApplicationDocuments />

export default withProviders([FilterProvider, { defaultFilters: ApplicationDocumentsDefaultFilters }])(ApplicationsDocumentsPage);